import { render, staticRenderFns } from "./IconCvc.vue?vue&type=template&id=11ce13ae&scoped=true"
import script from "./IconCvc.vue?vue&type=script&lang=js"
export * from "./IconCvc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ce13ae",
  null
  
)

export default component.exports